/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/clamp_min.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Clamps the sample values of all elements to have a lower limit of min.
 *
 * @example
 * clamp_min(http_requests_total, 0)
 */
const definition: PromqlFunctionDefinition = {
  type: 'value_transformation',
  name: 'clamp_min',
  signatures: [
    {
      params: [
        {
          name: 'v',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector input.',
        },
        {
          name: 'min',
          type: 'scalar',
          optional: false,
          description: 'Minimum value.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
